import {
    ENDPOINT_PATH_SKILL_QUESTS_MASTERY,
    ENDPOINT_PATH_ALL_TEACHERS,
    ENDPOINT_PATH_ALL_YEARS
} from '../../../helpers/constants';
import DateParamHelper from '../../../helpers/date-param-helper';
import Resources from '../../../helpers/resources';

import {
    ALL_TEACHERS,
    ALL_YEARS
} from '../../../components/report-filters/filter-constants';

export const SKILL_QUESTS_MASTERY_ALL_CLASSES_RETRIEVED =
    'SKILL_QUESTS_MASTERY_ALL_CLASSES_RETRIEVED';
export const SKILL_QUESTS_MASTERY_ALL_CLASSES_REQUEST =
    'SKILL_QUESTS_MASTERY_ALL_CLASSES_REQUEST';

function getSkillQuestsMasteryData(
    selectedDate,
    selectedYearGroupId,
    selectedTeacherId,
    assignmentResultType
) {
    return (dispatch, getState) => {
        const state = getState();
        if (state.isAdmin === true) {
            getAdminData(
                dispatch,
                selectedDate,
                selectedYearGroupId,
                selectedTeacherId,
                assignmentResultType
            );
        } else {
            getTeacherData(dispatch, selectedDate, assignmentResultType);
        }
    };
}

function getAdminData(
    dispatch,
    selectedDate,
    selectedYearGroupId,
    selectedTeacherId,
    assignmentResultType
) {
    let yearGroupId = ENDPOINT_PATH_ALL_YEARS;
    let teacherId = ENDPOINT_PATH_ALL_TEACHERS;
    let resource = 'yearGroupReport';

    if (selectedYearGroupId !== null && selectedYearGroupId !== ALL_YEARS) {
        yearGroupId = selectedYearGroupId;
    }
    if (selectedTeacherId !== null && selectedTeacherId !== ALL_TEACHERS) {
        teacherId = selectedTeacherId;
        resource = 'teacherReport';
    }

    const pathParams = {
        reportType: ENDPOINT_PATH_SKILL_QUESTS_MASTERY,
        ...DateParamHelper.getDateTypePath(selectedDate),
        yearGroupId,
        teacherId
    };
    const queryParams = {
        ...DateParamHelper.getDateQueryParams(selectedDate),
        assignmentResultType
    };

    getData({
        resource,
        dispatch,
        pathParams,
        queryParams
    });
}

function getTeacherData(dispatch, selectedDate, assignmentResultType) {
    const pathParams = {
        reportType: ENDPOINT_PATH_SKILL_QUESTS_MASTERY,
        ...DateParamHelper.getDateTypePath(selectedDate)
    };
    const queryParams = {
        ...DateParamHelper.getDateQueryParams(selectedDate),
        assignmentResultType
    };

    getData({
        resource: 'allClassesReport',
        dispatch,
        pathParams,
        queryParams
    });
}

function manageData(data) {
    data.classes.map((classLevel) => {
        classLevel.id = classLevel.classId;
        return classLevel;
    });
    return data;
}

function getData({ resource, dispatch, pathParams, queryParams }) {
    dispatch({ type: SKILL_QUESTS_MASTERY_ALL_CLASSES_REQUEST });
    Resources[resource]
        .get(pathParams)
        .withParams(queryParams)
        .send()
        .then((payload) => {
            // We need to add ids to class level to prevent console errors for DataTable display
            const returnedData = manageData(payload.data);
            dispatch({
                type: SKILL_QUESTS_MASTERY_ALL_CLASSES_RETRIEVED,
                payload: returnedData
            });
        });
}

export default {
    getSkillQuestsMasteryData
};



// WEBPACK FOOTER //
// ./containers/skill-quests-mastery/all-classes/all-classes-actions.js